import React from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Spinner } from 'tuui';
import styles from './DropdownLoader.module.scss';

const classNameBuilder = classnames.bind(styles);

export const DropdownLoader = ({ options }) => {
    const containerClassNames = classNameBuilder('container', {
        'top-border': options && options.length,
    });
    return <Spinner className={containerClassNames} size={21} />;
};

DropdownLoader.propTypes = {
    options: PropTypes.array,
};

export default DropdownLoader;
